/* eslint-disable react/prop-types */
import React from 'react';
import { Loader2 } from 'lucide-react';

// PostPreviewWrapper - handles layout containers
const PostPreviewWrapper = ({ layout, children, footer, loading }) => {
  if (layout === 'story') {
    return (
      <div
        className={`w-full flex items-center justify-center ${loading ? 'pointer-events-none animate-pulse' : ''}`}
      >
        <div className='flex flex-col relative' style={{ width: '100%' }}>
          <div
            className='relative bg-black rounded-t-lg overflow-hidden flex flex-col'
            style={{ aspectRatio: '9/16', width: '100%' }}
          >
            {children}
            {loading && (
              <div className='absolute inset-0 flex bg-transparent items-center justify-center z-10'>
                <Loader2 className='w-16 h-16 animate-spin' style={{ color: 'var(--brand)' }} />
              </div>
            )}
          </div>
          {footer && <div className='bg-black rounded-b-lg'>{footer}</div>}
        </div>
      </div>
    );
  }

  // Feed layout — white card to mimic real social platform UI
  return (
    <div
      className={`w-full flex items-center justify-center ${loading ? 'pointer-events-none animate-pulse' : ''}`}
    >
      <div
        className='rounded-lg overflow-hidden flex flex-col relative'
        style={{
          width: '100%',
          background: '#ffffff',
          border: '1px solid #dbdbdb',
        }}
      >
        {children}
        {loading && (
          <div className='absolute inset-0 flex items-center justify-center z-10'>
            <Loader2 className='w-16 h-16 animate-spin' style={{ color: 'var(--brand)' }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PostPreviewWrapper;
